export function generateToken(): string {
  const bytes = new Uint8Array(8);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => (b % 36).toString(36)).join("") + Date.now().toString(36).slice(-2);
}

export function generateId(prefix: string): string {
  return `${prefix}${Date.now().toString(36)}${Math.floor(Math.random() * 1000)}`;
}

export const joinUrl = (token: string) => `${window.location.origin}/join/${token}`;
export const checkinUrl = (token: string) => `${window.location.origin}/checkin/${token}`;
